class WaveOverlay extends HTMLElement {
  constructor() {
    super();
    this.updateMargin = this.updateMargin.bind(this);
  }

  connectedCallback() {
    // Initialize on mount
    this.updateMargin();

    // Update on resize
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateMargin();
      });
      this.resizeObserver.observe(this);
    } else {
      // Fallback for browsers without ResizeObserver
      window.addEventListener('resize', this.updateMargin);
    }

    // Update on load (in case images or other content affects layout)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.updateMargin);
    }
    window.addEventListener('load', this.updateMargin);
  }

  disconnectedCallback() {
    // Cleanup
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    } else {
      window.removeEventListener('resize', this.updateMargin);
    }
    window.removeEventListener('load', this.updateMargin);
    document.removeEventListener('DOMContentLoaded', this.updateMargin);
  }

  updateMargin() {
    const coverContent = this.getAttribute('data-cover');

    // If cover_content is "none", don't apply any margin
    if (!coverContent || coverContent === 'none') {
      this.style.marginTop = '';
      this.style.marginBottom = '';
      return;
    }

    // Get the height of the wave-overlay element
    const height = this.offsetHeight;

    // Apply negative margin based on the cover_content setting
    if (coverContent === 'top') {
      // Cover the top section - move up with negative margin-top
      this.style.marginTop = `-${height}px`;
      this.style.marginBottom = '';
    } else if (coverContent === 'bottom') {
      // Cover the bottom section - move down with negative margin-bottom
      this.style.marginTop = '';
      this.style.marginBottom = `-${height}px`;
    }
  }
}

// Register the custom element
if (!customElements.get('wave-overlay')) {
  customElements.define('wave-overlay', WaveOverlay);
}

